
(function() {
  // Add custom code below this line
  
  document.addEventListener("DOMContentLoaded", () => {
    console.log("DOM fully loaded. Starting MutationObserver script...");

    // 1) Map size names to their quart amounts
    const quartMap = {
      "Starter Bag":   "1 Quart",
      "Mini Bag":      "2 Quarts",
      "Junior Bag":    "4 Quarts",
      "Standard Bag":  "8 Quarts",
      "Half Box":      "16 Quarts",
      "Box":           "32 Quarts"
    };

    // 2) Select the <small> that updates automatically
    const optionValueEl = document.querySelector(
      ".radio__legend__value[data-option-value]"
    );
    // ...and the <span> we'll update
    const quartTextEl = document.getElementById("quart-text");

    // If either selector fails, log it and stop.
    if (!optionValueEl) {
      console.log("optionValueEl NOT FOUND. Check your selector for .radio__legend__value[data-option-value]");
      return;
    } else {
      console.log("optionValueEl found:", optionValueEl);
    }

    if (!quartTextEl) {
      console.log("quartTextEl NOT FOUND. Check your ID #quart-text");
      return;
    } else {
      console.log("quartTextEl found:", quartTextEl);
    }

    // 3) Function to map the text to quarts
    function updateQuartText(sizeName) {
      const newText = quartMap[sizeName] || "";
      console.log(`Updating quart text to: "${newText}" (for sizeName: "${sizeName}")`);
      quartTextEl.textContent = newText;
    }

    // 4) Observe the <small> for text changes
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        console.log("Mutation observed:", mutation);

        // childList means child text nodes changed
        // characterData means the text content changed
        if (mutation.type === "childList" || mutation.type === "characterData") {
          // Read the new text from the <small>
          const newSizeName = optionValueEl.textContent.trim();
          console.log("New size text detected:", newSizeName);
          updateQuartText(newSizeName);
        }
      });
    });

    observer.observe(optionValueEl, {
      childList: true,
      characterData: true,
      subtree: true
    });

    // 5) Set the initial text if there's a default selection
    const initialText = optionValueEl.textContent.trim();
    console.log("Initial text on load:", initialText);
    updateQuartText(initialText);
  });


})();
